var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "uploadShow",
      style: { width: _vm.width + "px", height: _vm.height + "px" },
      on: { mouseenter: _vm.mouseenter, mouseleave: _vm.mouseleave },
    },
    [
      _vm.getFileType(_vm.url).fileType === "img"
        ? [
            _c(
              "div",
              { staticClass: "fileView" },
              [
                _c("ImagePreviewer", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    src: _vm.url,
                    fit: "contain",
                    "preview-src-list": [_vm.url],
                  },
                }),
              ],
              1
            ),
          ]
        : ["video", "audio"].includes(_vm.getFileType(_vm.url).fileType)
        ? [
            _c(
              "div",
              {
                staticClass: "videoView",
                on: {
                  click: function ($event) {
                    _vm.playVideo(_vm.getFileType(_vm.url))
                  },
                },
              },
              [
                _c(
                  "el-image",
                  {
                    staticClass: "poster",
                    attrs: { src: _vm.getPoster(_vm.url), fit: "contain" },
                  },
                  [
                    _vm.getFileType(_vm.url).fileType === "video"
                      ? _c("img", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            slot: "error",
                            src: require("@/assets/image/jiazaishibia.png"),
                            alt: "",
                          },
                          slot: "error",
                        })
                      : _c("img", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            slot: "error",
                            src: require("@/assets/image/videoEmpty.png"),
                            alt: "",
                          },
                          slot: "error",
                        }),
                  ]
                ),
                _c("svg-icon", {
                  staticClass: "bofangIcon",
                  attrs: { "icon-class": "bofang" },
                }),
              ],
              1
            ),
          ]
        : ["file", "apk", "excel", "ppt", "pdf", "word"].includes(
            _vm.getFileType(_vm.url).fileType
          )
        ? [
            _c(
              "div",
              {
                staticClass: "fileView",
                on: {
                  click: function ($event) {
                    return _vm.previewFile(_vm.url)
                  },
                },
              },
              [
                ["excel", "xls", "xlsx"].includes(
                  _vm.getFileType(_vm.url).suffix
                )
                  ? _c("img", {
                      staticStyle: { width: "32px", height: "32px" },
                      attrs: {
                        src: require("@/assets/image/excel.png"),
                        alt: "",
                      },
                    })
                  : _vm.getFileType(_vm.url).suffix === "ppt"
                  ? _c("img", {
                      staticStyle: { width: "32px", height: "32px" },
                      attrs: {
                        src: require("@/assets/image/ppt.png"),
                        alt: "",
                      },
                    })
                  : _vm.getFileType(_vm.url).suffix === "pdf"
                  ? _c("img", {
                      staticStyle: { width: "32px", height: "32px" },
                      attrs: {
                        src: require("@/assets/image/ppt2.png"),
                        alt: "",
                      },
                    })
                  : _vm.getFileType(_vm.url).suffix === "txt"
                  ? _c("img", {
                      staticStyle: { width: "32px", height: "32px" },
                      attrs: {
                        src: require("@/assets/image/txt.png"),
                        alt: "",
                      },
                    })
                  : ["docx", "word", "doc", "rtf"].includes(
                      _vm.getFileType(_vm.url).suffix
                    )
                  ? _c("img", {
                      staticStyle: { width: "32px", height: "32px" },
                      attrs: {
                        src: require("@/assets/image/word.png"),
                        alt: "",
                      },
                    })
                  : _c("img", {
                      staticStyle: { width: "32px", height: "32px" },
                      attrs: {
                        src: require("@/assets/image/txt.png"),
                        alt: "",
                      },
                    }),
              ]
            ),
          ]
        : _vm._e(),
      _c("transition", { attrs: { name: "slide" } }, [
        !_vm.disabled
          ? _c(
              "div",
              { staticClass: "maskdShow" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticClass: "maskdShowText",
                    attrs: {
                      action: "#",
                      limit: 1,
                      accept: _vm.accept,
                      "before-upload": _vm.beforeUpload,
                      "http-request": _vm.upload,
                      "show-file-list": false,
                    },
                  },
                  [
                    _c("div", { staticClass: "maskdAginText" }, [
                      _vm._v(_vm._s(_vm.uploadShowArr[0])),
                    ]),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "maskdShowText maskdAginText",
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.onhandleClick(_vm.uploadShowArr[1])
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.uploadShowArr[1]))]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }